import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";
import { Link } from "react-router-dom";

function Mapper(data, status, response, error, component) {
	let output = [];
	let property = {};
	property["showTerms"] = "";
	output.push(property);

	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		id: {
			alias: "id",
			type: "text",
			editable,
		},
		period: {
			alias: "period",
			type: "text",
			editable: false,
		},
		periodMeasunit: {
			alias: "periodMeasunit",
			type: "text",
			editable: false,
		},
		tariff: {
			alias: "tariff",
			type: "text",
			editable,
		},
		teaser: {
			alias: "teaser",
			type: "text",
			editable,
		},
		confirm: {
			alias: "confirm",
			type: "button",
			caption: "Επιβεβαίωση",
			events: {
				onClick: function () {
					window.location.replace("/");
				},
			},
			editable,
		},
		showTerms: {
			alias: "showTerms",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				return (
					<div>
						<a
							className="open-terms open-lightbox"
							style={{ cursor: "pointer" }}
							onClick={(e) => clickMeTerm(_this)}>
							Όροι &amp; Προϋποθέσεις Χρήσης &gt;{" "}
						</a>
					</div>
				);
			},
		},
	};
}

function clickMeTerm(_this) {
	let id = _this.props.primaryKey;
	let manager = _this.props.manager;
	window["modal"].setState({
		// title: <h4>Confirm deletion</h4>,
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		// footer: [
		// ],
		body: (
			<Manager
				key="modalForTerms"
				module="modalForTerms"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

function popUpMessages() {
	let UserType = Functions["custom"]["getUserType"]();
	let landPageData = JSON.parse(sessionStorage.landPageData);
	if (
		UserType === "POSTB" ||
		UserType === "POSTR" ||
		UserType === "POSTB_SPLIT"
	) {
		return (
			<h2>
				Έχετε επιλέξει την ενεργοποίηση
				<br /> του αυτόματου μηχανισμού
				<br /> ενημέρωσης.
			</h2>
		);
	} else {
		return (
			<h2>
				Έχεις επιλέξει την ενεργοποίηση
				<br />
				της υπηρεσίας
				<br />
				My Internet
			</h2>
		);
	}
}

const ModalForActivation = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: [{}],
					replace: {},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				cardTopTemplate: function () {
					let data = this.state.data[0];
					return (
						<div
							className="lightbox"
							id="activation-confirm"
							style={{ display: "block" }}>
							<div className="content">
								<div className="package-cyrcle">
									<div className="icon"></div>
								</div>
								{popUpMessages()}
								<h3>Αποδέχομαι τους:</h3>

								{data.showTerms.component}
								<Link
									className="submit customClassActivateLandingPage customClassAddCursorPointer"
									style={{ cursor: "pointer" }}
									to="/thank_you"
									onClick={() => {
										window["modal"].setState({ show: false });
									}}>
									Επιβεβαίωση
								</Link>
								<a
									className="cancel customClassAddCursorPointer addCursorPointer"
									style={{ cursor: "pointer" }}
									onClick={() => {
										window["modal"].setState({ show: false });
									}}>
									Ακύρωση &gt;
								</a>
							</div>
						</div>
					);
				},
				includeProperties: ["none"],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default ModalForActivation;
